"use strict";Object.defineProperties(exports,{__esModule:{value:!0},[Symbol.toStringTag]:{value:"Module"}});require('./clickableText.css');const e="_clickable_1sggq_1",l={clickable:e};exports.clickable=e;exports.default=l;
//# sourceMappingURL=clickableText.module.css.cjs.map
